import PendingCases from "./PendingCases";

export default PendingCases;
